export default function(link) {
  console.log(link);
  const lang = link.split('/').filter((item) => !!item)[0];
  if (lang === 'ua' || lang === 'ru') {
    return lang;
  } else {
    return ''
  }
}